/*
Home controller
*/

import BaseController from './base.js';
import HomeView from '../view/home/home.jsx';


export default class Controller extends BaseController{
  constructor(options) {
    super(options);

    // this.events = {};

  }
  ///action methods/////
  index() {
    //re-render the page being requested
    // console.log('Index route is to be implemented...');
    var currentView = <HomeView/> ;
    this.viewPort.render(currentView);

  }

};



// WEBPACK FOOTER //
// src/js/controller/home.js